module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-history"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.navigate
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Отзывы",
      "name": "BrandReviews"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Достижения",
      "name": "BrandAchievements"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Рекомендации",
      "name": "BrandRecommendations"
    }
  })], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-485e6a1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/Index.vue
// module id = 942
// module chunks = 0